<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_alliances')
}

const isOnAlliancesSection = computed(() => {
  return route.path.startsWith('/diplomacy/alliances')
})

const goToAlliances = () => {
  router.push('/diplomacy/alliances')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        Alliances are powerful coalitions of players working together toward common goals.
      </p>
      <p class="pb-2">
        By joining (or creating) an alliance, you gain access to shared research, map data, chat, and mutual defense pacts.
      </p>
      <p class="pb-2">

      </p>
      <p class="pb-2">
        Remember: In the vastness of space, trusted allies can mean the difference between thriving and merely surviving!
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on the "Alliances" tab within the "Diplomacy" section.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnAlliancesSection" @click="goToAlliances" class="mr-2">
        View Alliances
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>